import { INVOICE_REPORTS } from "../../constant/ActionType";

export default function dashboardallinvoicereports(state = {
    invoicereportsget: [],
    statuscode: null,
}, action) {
    switch (action.type) {
        case INVOICE_REPORTS:
            return {
                ...state,
                invoicereportsget: action.data,
                statuscode: action.status
            };

        default:
            console.log("checkingg", action)
    }
    return state;
}
